var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,0C5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12S18.617,0,12,0Zm-3.143,18c-.723,0-1.449-.261-2-.813l-.522-.6c-.446-.446-.446-1.17,0-1.616l1.302-1c.446-.446,1.17-.446,1.616,0l1.069,.851c2.071-.791,3.599-2.256,4.5-4.5l-.851-1.069c-.446-.446-.446-1.17,0-1.616l1-1.302c.446-.446,1.17-.446,1.616,0l.6,.522c.552,.551,.813,1.277,.813,2,0,4-5.429,9.143-9.143,9.143Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.15adea96ece888c448242721e99e635e.svg";
export { ForwardRef as ReactComponent };